module.exports = __webpack_public_path__ + "img/banner-img2x.8c0bdc1e.png";